module.exports = __webpack_public_path__ + "img/dillan_johnson_valley_of_fire-min.b14e151b.jpg";